import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "what-is-interventional-psychiatry",
  title: "What Is Interventional Psychiatry?",
  description:
    "Interventional psychiatry uses treatments that work through different mechanisms than oral medication — including TMS, SAINT®, SPRAVATO®, and ketamine. Learn what it means.",
  keywords:
    "interventional psychiatry, what is interventional psychiatry, TMS SPRAVATO ketamine, interventional mental health",
  badge: "Educational Article",
  heroTitle: "What Is Interventional Psychiatry?",
  heroSubtitle:
    "Interventional psychiatry refers to treatments that work through different mechanisms than oral medication — treatments like TMS, SAINT®, SPRAVATO®, and ketamine that act directly on brain activity.",
  sections: [
    {
      heading: "Beyond Medication and Therapy",
      body: "Traditional psychiatric treatment often involves oral medication and psychotherapy. Interventional psychiatry adds treatments that use magnetic stimulation, targeted medication delivery, or IV infusions to influence brain activity directly.",
    },
    {
      heading: "Who It's For",
      body: "Interventional treatments are often considered when standard treatments haven't provided adequate relief — that is, for treatment-resistant depression. They're not first-line treatments for everyone, but they may be appropriate when other approaches haven't been enough.",
    },
    {
      heading: "Examples of Interventional Treatments",
      body: "TMS and SAINT® use magnetic stimulation. SPRAVATO® uses a prescription nasal spray administered under supervision. IV ketamine uses infusions. Each works through a different mechanism, and each has its own evidence base and considerations.",
    },
    {
      heading: "It's Collaborative, Not a Replacement",
      body: "Interventional treatments may be used alongside medication and therapy, not necessarily instead of them. The goal is a coordinated plan that addresses your individual situation.",
      callout: true,
    },
  ],
  faq: [
    {
      question: "Is interventional psychiatry experimental?",
      answer:
        "No. Several interventional treatments are FDA-cleared or FDA-approved. TMS is FDA-cleared for depression. SAINT® is FDA-cleared. SPRAVATO® is FDA-approved. They are established treatments, not experimental.",
    },
    {
      question: "Do I have to stop medication to try interventional treatment?",
      answer:
        "Not necessarily. Interventional treatments may be used alongside medication. Do not stop or change medication without discussing it with your prescribing provider.",
    },
  ],
  related: [
    {
      title: "Depression Treatment Options",
      href: "/depression-treatment-options",
    },
    {
      title: "Compare Depression Treatments",
      href: "/compare-treatments",
    },
    {
      title: "What Is Treatment-Resistant Depression?",
      href: "/what-is-treatment-resistant-depression",
    },
  ],
  finalCtaText:
    "Interventional psychiatry offers approaches beyond standard medication. Speak with our team to learn more.",
});
